export var ERequestStatus;

(function (ERequestStatus) {
  ERequestStatus["Failure"] = "failure";
  ERequestStatus["Initial"] = "initial";
  ERequestStatus["Loading"] = "loading";
  ERequestStatus["Success"] = "success";
})(ERequestStatus || (ERequestStatus = {}));